import React from 'react';
import PropTypes from 'prop-types';
import SidePanel from '../SidePanel';
import { RadioButtonMedium } from '../RadioButton';

/**
 * FilterSortSheet — the sort choices on phones (internal): a bottom sheet of
 * DS RadioButtonMedium rows. A pick applies and closes at once; pressing the
 * current one again just closes.
 */
const FilterSortSheet = ({ isOpen, onClose, onPick, options, sort, labels, name }) => (
  <SidePanel
    isOpen={isOpen}
    onClose={onClose}
    title={labels.sort}
    size="m"
    mobileSheet
    sheetHeader="row"
    closeLabel={labels.close}
    restoreFocus
    className="ds-filter-sort-sheet"
  >
    <div className="ds-filter-sort-sheet__list" role="radiogroup" aria-label={labels.sort}>
      {options.map((option) => (
        <RadioButtonMedium
          key={option.value}
          name={name}
          value={option.value}
          title={option.label}
          checked={sort === option.value}
          onChange={() => onPick(option.value)}
          onClick={() => {
            if (sort === option.value) onPick(option.value);
          }}
        />
      ))}
    </div>
  </SidePanel>
);

FilterSortSheet.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onPick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  sort: PropTypes.string,
  labels: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

export default FilterSortSheet;
